export default __webpack_public_path__ + "static/media/themebel_main_mobile.ed20b056.svg";